export default {
  metadata: {
    version: '1.0.0',
    id: 'Rating-bar-1.0.0',
    name: 'JDSRatingBar'
  },
  hierarchy: {
    'vertical-container': [
      'top_label-jds-text',
      {
        'horizontal-container': [
          'left_label-jds-text',
          'compact-jds_rating_bar_item',
          {
            'rating-bar-container': ['jds_rating_bar_item']
          },
          'right_label-jds-text',
          'right_support-jds-text'
        ]
      },
      'bottom_label-jds-text',
      'bottom_support-jds-text',
      'jds_feedback_block'
    ]
  },
  base: {
    'vertical-container': {
      'flex-direction': '{r_0}',
      'align-items': '{r_1}',
      'justify-content': '{r_2}',
      gap: '{r_3}'
    },
    'horizontal-container': {
      'flex-direction': '{r_4}',
      'align-items': '{r_26}',
      'justify-content': '{r_6}',
      gap: '{r_7}'
    },
    'compact-jds_rating_bar_item': {
      hidden: true,
      isInteractive: false,
      isActive: true,
      isHalfRated: false,
      size: 'medium'
    },
    'rating-bar-container': {
      'flex-direction': '{r_8}'
    },
    jds_feedback_block: {
      size: 'l',
      hidden: true
    },
    'top_label-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    },
    'left_label-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'right_label-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'bottom_label-jds-text': {
      'font-family': '{text_137}',
      color: '{text_20}',
      'font-size': '{text_136}',
      'line-height': '{text_138}',
      'letter-spacing': '{text_139}',
      'font-weight': '{text_140}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'right_support-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: true
    },
    'bottom_support-jds-text': {
      'font-family': '{text_132}',
      color: '{text_21}',
      'font-size': '{text_131}',
      'line-height': '{text_133}',
      'letter-spacing': '{text_134}',
      'font-weight': '{text_135}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    size: {
      small: {
        'vertical-container': {
          gap: '{r_9}'
        },
        'horizontal-container': {
          gap: '{r_10}'
        },
        'compact-jds_rating_bar_item': {
          size: 'small'
        },
        'top_label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        },
        'left_label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        },
        'right_label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        },
        'bottom_label-jds-text': {
          'font-family': '{text_172}',
          'font-size': '{text_171}',
          'line-height': '{text_173}',
          'letter-spacing': '{text_174}',
          'font-weight': '{text_175}'
        },
        'right_support-jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        },
        'bottom_support-jds-text': {
          'font-family': '{text_167}',
          'font-size': '{text_166}',
          'line-height': '{text_168}',
          'letter-spacing': '{text_169}',
          'font-weight': '{text_170}'
        }
      },
      large: {
        'compact-jds_rating_bar_item': {
          size: 'large'
        }
      }
    },
    labelPosition: {
      bottom_center: {
        'vertical-container': {
          'align-items': '{r_11}'
        },
        'top_label-jds-text': {
          hidden: true
        },
        'bottom_label-jds-text': {
          hidden: false
        }
      },
      bottom_left: {
        'top_label-jds-text': {
          hidden: true
        },
        'bottom_label-jds-text': {
          hidden: false
        }
      },
      top_center: {
        'vertical-container': {
          'align-items': '{r_12}'
        }
      },
      right: {
        'top_label-jds-text': {
          hidden: true
        },
        'right_label-jds-text': {
          hidden: false
        },
        'bottom_support-jds-text': {
          hidden: true
        },
        'right_support-jds-text': {
          hidden: false
        }
      },
      left: {
        'top_label-jds-text': {
          hidden: true
        },
        'left_label-jds-text': {
          hidden: false
        },
        'bottom_support-jds-text': {
          hidden: true
        },
        'right_support-jds-text': {
          hidden: false
        }
      }
    },
    type: {
      read_only_expanded: {
        'rating-bar-container': {
          disabled: true
        },
        jds_rating_bar_item: {
          isInteractive: false
        }
      },
      read_only_compact: {
        'rating-bar-container': {
          hidden: true
        },
        'compact-jds_rating_bar_item': {
          hidden: false
        }
      }
    },
    disabled: {
      true: {
        'vertical-container': {
          disabled: true,
          opacity: '{r_13}'
        }
      }
    },
    state: {
      success: {
        jds_feedback_block: {
          hidden: false
        }
      },
      error: {
        jds_feedback_block: {
          hidden: false
        }
      },
      warning: {
        jds_feedback_block: {
          hidden: false
        }
      }
    }
  },
  combination: [
    {
      read_only_compact: {
        top_left: {
          'top_label-jds-text': {
            hidden: true
          },
          'right_label-jds-text': {
            hidden: false
          }
        },
        top_center: {
          'top_label-jds-text': {
            hidden: true
          },
          'right_label-jds-text': {
            hidden: false
          }
        },
        bottom_left: {
          'bottom_label-jds-text': {},
          'right_label-jds-text': {
            hidden: false
          }
        },
        bottom_center: {
          'bottom_label-jds-text': {},
          'right_label-jds-text': {
            hidden: false
          }
        }
      }
    },
    {
      read_only_expanded: {
        small: {
          'vertical-container': {
            gap: '{r_15}'
          },
          'horizontal-container': {
            gap: '{r_14}'
          }
        },
        medium: {
          'vertical-container': {
            gap: '{r_16}'
          },
          'horizontal-container': {
            gap: '{r_17}'
          }
        },
        large: {
          'vertical-container': {
            gap: '{r_18}'
          },
          'horizontal-container': {
            gap: '{r_19}'
          }
        }
      },
      read_only_compact: {
        small: {
          'vertical-container': {
            gap: '{r_21}'
          },
          'horizontal-container': {
            gap: '{r_20}'
          }
        },
        medium: {
          'vertical-container': {
            gap: '{r_22}'
          },
          'horizontal-container': {
            gap: '{r_23}'
          }
        },
        large: {
          'vertical-container': {
            gap: '{r_24}'
          },
          'horizontal-container': {
            gap: '{r_25}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['type', 'labelPosition'],
    ['type', 'size']
  ],
  api: {
    config: {
      size: {
        type: 'JDSRatingBarItem.size',
        values: ['medium', 'small', 'large']
      },
      labelPosition: {
        values: [
          'top_left',
          'bottom_left',
          'top_center',
          'bottom_center',
          'right',
          'left'
        ]
      },
      type: {
        values: ['interactive', 'read_only_expanded', 'read_only_compact']
      },
      disabled: {
        values: [false, true]
      },
      state: {
        type: 'JDSFeedbackBlock.state',
        values: ['none', 'success', 'error', 'warning']
      }
    },
    data: {
      'rating-bar-container': {
        value: {
          type: 'list',
          name: '_items',
          object: {
            isInteractive: 'boolean',
            isActive: 'boolean',
            isHalfRated: 'boolean',
            isHovered: 'boolean',
            rating: 'clipValueSize'
          }
        },
        '_items.rating': {
          type: 'float',
          name: 'rating'
        },
        '_items.count': {
          type: 'number',
          name: 'count'
        }
      },
      jds_rating_bar_item: {
        size: {
          type: 'JDSRatingBarItem.size',
          name: 'size'
        },
        isInteractive: {
          type: 'boolean',
          name: '_items.isInteractive'
        },
        isActive: {
          type: 'boolean',
          name: '_items.isActive'
        },
        isHovered: {
          type: 'boolean',
          name: '_items.isHovered'
        },
        isHalfRated: {
          type: 'boolean',
          name: '_items.isHalfRated'
        },
        disabled: {
          type: 'boolean',
          name: 'disabled'
        },
        clipValue: {
          type: 'clipValueSize',
          name: '_items.rating'
        }
      },
      jds_feedback_block: {
        stateText: {
          type: 'string',
          name: 'stateText'
        },
        state: {
          type: 'JDSFeedbackBlock.state',
          name: 'state'
        }
      },
      'top_label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'left_label-jds-text': {
        value: {
          type: 'string',
          name: '_label'
        }
      },
      'right_label-jds-text': {
        value: {
          type: 'string',
          name: '_label'
        }
      },
      'bottom_label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      'right_support-jds-text': {
        value: {
          type: 'string',
          name: 'supportText'
        }
      },
      'bottom_support-jds-text': {
        value: {
          type: 'string',
          name: 'supportText'
        }
      }
    },
    events: {
      jds_rating_bar_item: {
        onClick: 'onChange',
        onHover: {
          name: '_onHover',
          platform: 'web'
        },
        onHoverEnd: {
          name: '_onHoverEnd',
          platform: 'web'
        }
      }
    },
    a11y: {
      'vertical-container': {
        properties: {
          role: {
            name: '_role'
          },
          'aria-label': {
            name: 'ariaLabel',
            function: true
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      'rating-bar-container': {
        name: '_items',
        repeating: {
          ariaLabel: 'itemAriaLabel',
          ariaChecked: 'itemAriaChecked'
        }
      },
      jds_rating_bar_item: {
        properties: {
          ariaLabel: '_items.itemAriaLabel',
          ariaChecked: '_items.itemAriaChecked'
        }
      }
    }
  }
};
